import { render, staticRenderFns } from "./IsMobileSummary.vue?vue&type=template&id=b49e9a5c&scoped=true"
import script from "./IsMobileSummary.vue?vue&type=script&lang=js"
export * from "./IsMobileSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49e9a5c",
  null
  
)

export default component.exports